module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('regstep', {
    attrs: {
      "step": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "md regauto"
  }, [_c('div', {
    staticClass: "regbox"
  }, [_c('div', {
    staticClass: "base-info"
  }, [_vm._v("最后一步啦~请填写您公司HR的基本信息。")]), _vm._v(" "), _c('div', {
    staticClass: "reg-item clearfix"
  }, [_c('div', {
    staticClass: "reg-txt",
    staticStyle: {
      "float": "left",
      "margin-top": "34px"
    }
  }, [_vm._v("头像：")]), _vm._v(" "), _c('div', {
    staticClass: "hrface-chaun"
  }, [_c('input', {
    staticClass: "hrface-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.faceChange
    }
  }), _vm._v(" "), (!_vm.headImage) ? _c('img', {
    staticClass: "logoimg",
    attrs: {
      "src": require("../../assets/images/logochuan.png")
    }
  }) : _c('img', {
    staticClass: "logoimg",
    attrs: {
      "src": _vm.headImage
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "reg-item"
  }, [_c('div', {
    staticClass: "reg-txt"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('div', {
    staticClass: "reg-ms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "reg-inp",
    attrs: {
      "type": "text",
      "placeholder": "请输入HR的姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-top": "30px"
    },
    on: {
      "click": _vm.gostep
    }
  }, [_vm._v("下一步")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f39c059","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/hrinfo.vue
// module id = 869
// module chunks = 1